export const style = {
  link: {
    color: `#A94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Info/style/list.js